import { render, staticRenderFns } from "./NewBoxLinePropertyEditor.vue?vue&type=template&id=0f4478d4&scoped=true&"
import script from "./NewBoxLinePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewBoxLinePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4478d4",
  null
  
)

export default component.exports